import { gql } from '@apollo/client'
import { FEATURE_CODES } from '@jusbrasil-web/docview/core'

import { ConvertDocumentButtonBase } from '../../convert-document-button-base'
import {
  ConvertMotionButton_DocumentFragment,
  ConvertMotionButton_ViewerFragment,
} from './__generated__/convert-motion-button.graphql'

export interface ConvertMotionButtonProps {
  document: ConvertMotionButton_DocumentFragment
  viewer: ConvertMotionButton_ViewerFragment | null
  onClick?: (successfulAttempt: boolean) => void
  disabled?: boolean
}

const boxProps = {
  featureCode: FEATURE_CODES.DOWNLOAD_PECAS_CONTENT,
  fromComponent: 'docview/ConvertDocumentButton',
}

export function ConvertMotionButton(props: ConvertMotionButtonProps) {
  const { document, viewer, onClick, disabled = false } = props
  return (
    <ConvertDocumentButtonBase
      document={document}
      viewer={viewer}
      onClick={onClick}
      boxProps={boxProps}
      ga4EventLabel="MotionContent"
      disabled={disabled}
      viewerCanDownload={document.viewerCanDownload}
    />
  )
}

ConvertMotionButton.fragments = {
  document: gql`
    fragment ConvertMotionButton_document on Document {
      viewerCanDownload: viewerCanUseFeature(featureCode: "download_pecas_content")
      ...ConvertDocumentButtonBase_document
    }
    ${ConvertDocumentButtonBase.fragments.document}
  `,
  viewer: gql`
    fragment ConvertMotionButton_viewer on Profile {
      ...ConvertDocumentButtonBase_viewer
    }
    ${ConvertDocumentButtonBase.fragments.viewer}
  `,
}
